query BusinessUnitsTableData(
  $days: Int!
  $environmentFilter: ConditionString
  $calculationDates: ConditionDateTime
) {
  score_web_products(
    calculation_date_eq: $calculationDates
    timeframe_days_eq: { value: [$days] }
    environment_eq: $environmentFilter
  ) {
    unit_id
    environment
    timeframe_days
    unique_issues
    unique_issues_critical
    total_issues
    total_issues_critical
    total_issues_serious
    score
    calculation_date
  }
}
